<template>
	<NuxtLink
		:to="link"
		target="_blank"
		class="rounded-2xl bg-primary-900 p-5 w-full text-white transition-all hover:shadow-[0_0_20px_rgba(80,181,255,0.6)]"
	>
		<div
			class="flex items-center justify-center gap-2 bg-yellow-500 text-black font-semibold rounded-xl px-6 py-3 mb-5 w-full transition-all duration-150 focus:outline-none"
		>
			<svg
				width="23"
				height="14"
				viewBox="0 0 23 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2.5 0C1.397 0 0.5 0.897 0.5 2V12C0.5 13.103 1.397 14 2.5 14H15.5C16.603 14 17.5 13.103 17.5 12V9.08008L22.5 13.0801V0.919922L17.5 4.91992V2C17.5 0.897 16.603 0 15.5 0H2.5Z"
					fill="#091D56"
				/>
			</svg>

			<span class="tracking-wide text-base font-bold">WATCH LIVE STREAM</span>
		</div>

		<!-- Current Event -->
		<div class="flex items-center justify-between mb-3">
			<div class="flex items-center gap-3">
				<img
					src="/images/gravatar-compound-1.png"
					alt="Host 1"
					class="object-cover h-7 rounded-full"
				/>
				<span class="font-bold text-white text-base line-clamp-1">
					Fast Money Halftime Report
				</span>
			</div>
			<span class="text-white text-sm font-medium">NOW</span>
		</div>

		<hr class="my-3 border-white/20" />

		<!-- Upcoming Event -->
		<div class="flex items-center justify-between">
			<div class="flex items-center gap-3">
				<img
					src="/images/gravatar-compound-2.png"
					alt="Host 2"
					class="object-cover h-7 rounded-full"
				/>
				<span class="text-white text-base">The Exchange</span>
			</div>
			<span class="text-white text-sm font-medium">UP NEXT</span>
		</div>
	</NuxtLink>
</template>

<script setup>
const WATCH_LIVE_FALLBACK =
	"https://university.stockstotrade.com/room/stockstotrade-live?utm_source=webinar_launch&utm_medium=web_ads&utm_term=web_ads&utm_campaign=EjKAQi";
const observedLink = ref(WATCH_LIVE_FALLBACK);
const link = useCampaignUrl(observedLink);

onMounted(() => {
	if (import.meta.client) {
		const targetElement = document.querySelector(".watch-live-stt-header");

		if (targetElement) {
			// Create a MutationObserver to watch for changes
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					// Check if nodes were added
					if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
						mutation.addedNodes.forEach((node) => {
							// Check if the added node is an anchor tag
							if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "A") {
								const href = node.getAttribute("href");
								if (href) {
									observedLink.value = href;
								}
							}
							// Also check if the added node contains anchor tags
							else if (node.nodeType === Node.ELEMENT_NODE) {
								const anchorTags = node.querySelectorAll("a");
								anchorTags.forEach((anchor) => {
									const href = anchor.getAttribute("href");
									if (href) {
										observedLink.value = href;
									}
								});
							}
						});
					}

					// Check if attributes were modified (in case href is added to existing anchor)
					if (mutation.type === "attributes" && mutation.attributeName === "href") {
						const href = mutation.target.getAttribute("href");
						if (href && mutation.target.tagName === "A") {
							observedLink.value = href;
						}
					}
				});
			});

			// Start observing
			observer.observe(targetElement, {
				childList: true, // Watch for added/removed children
				subtree: true, // Watch all descendants
				attributes: true, // Watch for attribute changes
				attributeFilter: ["href"] // Only watch href attribute changes
			});

			// Cleanup observer on component unmount
			onUnmounted(() => {
				observer.disconnect();
			});
		}
	}
});
</script>
